<template>
  <NavigationBarTop />
  <LandingPageHSVue />
  <FooterBarBelow />
</template>

<script>
import NavigationBarTop from '../components/NavigationBarTop.vue'
import LandingPageHSVue from '../components/LandingPageHS.vue'
import FooterBarBelow from '@/components/FooterBarBelow.vue'

export default {
  name: 'HomeView',
  components: {
    NavigationBarTop,
    LandingPageHSVue,
    FooterBarBelow
  }
}
</script>
